// extracted by mini-css-extract-plugin
module.exports = {"section":"HighlightTextAni_section__7tFxn"};